import { component } from 'picoapp'
import $ from 'quantdom'
import SubscriptionListSelectors from '../lib/subscription-list-selectors'
import { centsToDollars, getProduct, getBuyBoxVariant } from '../lib/utils'

export default component( async (node) => {
  const handle = $(node).attr('data-handle')
  const productData = getProduct(handle)
  const product = await productData

  let currentVariant = window.Solawave_Store.current_variant || getBuyBoxVariant(product)

  new SubscriptionListSelectors({ el: node }, (e) => {
    $('[data-selling-plan-id]')?.attr('data-selling-plan-id', e.selectedSellingPlanId)

    if (e.selectedSellingPlanId) {
      const plan = currentVariant.selling_plan_allocations.find((plan) => plan.selling_plan_id == e.selectedSellingPlanId)
      const price = plan.price
      const compareAtPrice = currentVariant.compare_at_price ?? plan.compare_at_price
      $('.js-pdp-main .js-price').text('$' + centsToDollars(price))
      $('.js-pdp-main .js-split-price').text('$' + centsToDollars(price / 4))

      if (compareAtPrice > price) {
        $('.js-pdp-main .js-sub-compare-price').text('$' + centsToDollars(compareAtPrice))
        $('.js-pdp-main .js-price-savings').text('$' + centsToDollars(compareAtPrice - price))
        $('.js-pdp-main .js-main-prices .js-compare-price').text('$' + centsToDollars(compareAtPrice))
        $('.js-pdp-main .js-compare-price').show()
        $('.js-pdp-main .js-price-savings-wrapper').show()
      } else {
        $('.js-pdp-main .js-compare-price').hide()
        $('.js-pdp-main .js-price-savings-wrapper').hide()
      }
    } else {
      $('.js-pdp-main .js-price').text(`$${centsToDollars(currentVariant.price)}`)
      $('.js-pdp-main .js-split-price').text('$' + centsToDollars(currentVariant.price / 4))
      if (currentVariant?.compare_at_price > currentVariant.price) {
        $('.js-pdp-main .js-compare-price').text('$' + centsToDollars(currentVariant?.compare_at_price))
        $('.js-pdp-main .js-price-savings').text(
          '$' + centsToDollars(currentVariant.compare_at_price - currentVariant.price)
        )
        $('.js-pdp-main .js-compare-price').show()
        $('.js-pdp-main .js-price-savings-wrapper').show()
      } else {
        $('.js-pdp-main .js-compare-price').hide()
        $('.js-pdp-main .js-price-savings-wrapper').hide()
      }
    }
  })

  window.MicroBus.on('variant:change', (e) => {
    const { variant, location } = e.detail
    if (location !== 'buybox') return
    currentVariant = variant
    const selectedFrequency = $('.js-subscription-selector-list input:checked').val()

    if (selectedFrequency == 'one-time') {
      $('[data-selling-plan-id]')?.attr('data-selling-plan-id', '')
    } else {
      const selectedSellingPlanId = $(
        ".js-subscription-selector-list label[aria-checked='true'] .js-delivery-cadence-selector option[selected='selected']"
      ).val()
      const currentSellingPlan = e.detail.variant.selling_plan_allocations.find(
        (plan) => plan.selling_plan_id == selectedSellingPlanId
      )

      $('[data-selling-plan-id]')?.attr('data-selling-plan-id', selectedSellingPlanId)
      const compareAtPrice = currentVariant.compare_at_price ?? currentSellingPlan?.compare_at_price
      // update product price & split price
      if (compareAtPrice > currentSellingPlan?.price) {
        $('.js-pdp-main .js-sub-compare-price').text('$' + centsToDollars(compareAtPrice))
        $('.js-pdp-main .js-price').text(`$` + centsToDollars(currentSellingPlan?.price))
        $('.js-pdp-main .js-split-price').text('$' + centsToDollars(currentSellingPlan?.price / 4))
        $('.js-pdp-main .js-price-savings').text('$' + centsToDollars(compareAtPrice - currentSellingPlan?.price))
        $('.js-pdp-main .js-compare-price').show()
        $('.js-pdp-main .js-price-savings-wrapper').show()
      } else {
        $('.js-pdp-main .js-compare-price').hide()
        $('.js-pdp-main .js-price-savings-wrapper').hide()
      }
    }

    //update prices
    e.detail.variant.selling_plan_allocations.forEach((sellingPlan) => {
      $(node)
        .find(`label[data-selling-plan-group="${sellingPlan.selling_plan_group_id}"] .js-sub-price`)
        .text(`$${centsToDollars(sellingPlan.price)}`)
    })

    $(node)
      .find('.js-one-time-price')
      .text(`$${centsToDollars(e.detail.variant.price)}`)

    $(node)
      .find('.js-sub-compare-price')
      .text(`$${centsToDollars(e.detail.variant.compare_at_price)}`)

    $('.js-show-variant-selected').each((el) => {
      if (el.attributes['data-variant-id'].value == e.detail.variant.id) {
        el.classList.remove('tw-hidden')
      } else {
        el.classList.add('tw-hidden')
      }
    })
  })
})
